import { List } from "immutable";

import { Dispatch } from "common/types";

import SessionReport from "seneca-common/features/session/models/SessionReport";
import {
  applyCompleteModuleEventToContentStat,
  ContentStat,
  ModuleStudiedEvent,
  receiveReconciledContentStudyStats
} from "seneca-common/features/stats/state";

export const reconcileContentStudyStats = (
  sessionReport: SessionReport,
  contentStats: List<ContentStat>,
  contentIds: List<string>,
  dispatch: Dispatch
) => {
  const contentIdsWithoutStats = contentIds.filter(
    (contentId: string) =>
      !contentStats.find((stat: any) => stat.contentId === contentId)
  );
  const reconciledStudyStats: List<ContentStat | null> = contentStats
    .map(contentStat =>
      reconcileIndividualContentStudyStat(
        sessionReport,
        contentStat.contentId!,
        contentStat
      )
    )
    .concat(
      contentIdsWithoutStats.reduce((newContentStats, contentId) => {
        const newStat = reconcileIndividualContentStudyStat(
          sessionReport,
          contentId
        );

        if (newStat) {
          newContentStats = newContentStats.push(newStat);
        }

        return newContentStats;
      }, List())
    );

  // @ts-ignore
  dispatch(receiveReconciledContentStudyStats(reconciledStudyStats));
  return reconciledStudyStats;
};

const reconcileIndividualContentStudyStat = (
  sessionReport: SessionReport,
  contentId: string,
  contentStat?: ContentStat
): ContentStat | null => {
  let newStat = contentStat;

  const relevantModuleStudiedEvents = getRelevantModuleStudiedEventsForContent(
    contentId,
    sessionReport
  );

  if (relevantModuleStudiedEvents.size === 0 && !newStat) {
    return null;
  }

  if (!newStat)
    newStat = new ContentStat({
      contentId
    });

  relevantModuleStudiedEvents.forEach((event: any) => {
    newStat = applyCompleteModuleEventToContentStat(newStat!, event, {
      logUpdateSpacingWarnings: false
    });
  });

  return newStat;
};

const getRelevantModuleStudiedEventsForContent = (
  contentId: string,
  sessionReport: SessionReport
): List<ModuleStudiedEvent> => {
  return sessionReport.modules.filter(module => module.contentId === contentId);
};
